import { useContext, useState } from 'react';
import { Delete as DeleteIcon } from '@mui/icons-material';
import Dialog from '@/components/Dialog';
import { FormattedMessage } from 'react-intl';
import PortfolioItemContext from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemContext';
import useApi from '@/lib/api/useApi';
import { type CoachComment } from '@/lib/types';
import CommentActionButton from './styled-components/CommentActionButton';

type DeleteCoachCommentProps = {
  coachComment: CoachComment;
};

const DeleteCoachComment = ({ coachComment }: DeleteCoachCommentProps) => {
  const api = useApi();

  const { setPortfolioItem, portfolioItemApiEndpoint } =
    useContext(PortfolioItemContext);

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const deleteCoachComment = async (): Promise<void> => {
    setConfirmationDialogOpen(false);
    setDeleting(true);

    await api.delete(
      `${portfolioItemApiEndpoint}/coach-comments/${coachComment.id}`,
    );

    setPortfolioItem(portfolioItem => {
      delete portfolioItem.coachComments[coachComment.id];
    });

    setDeleting(false);
  };

  return (
    <>
      <CommentActionButton
        onClick={() => setConfirmationDialogOpen(true)}
        disabled={deleting}
        dangerous
      >
        <DeleteIcon fontSize="small" />
      </CommentActionButton>
      <Dialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        dangerous
      >
        <Dialog.Title>
          <FormattedMessage id="portfolio.challenge.coach_comments.coach_comment.delete.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessage id="portfolio.challenge.coach_comments.coach_comment.delete.text" />
          </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.CancelButton
            onClick={() => setConfirmationDialogOpen(false)}
          />
          <Dialog.Actions.DeleteButton onClick={deleteCoachComment} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default DeleteCoachComment;
